module.exports = __webpack_public_path__ + "static/bromeliad-0-610dba02382db045f07f76648b72d837.png";